import CryptoJS from 'crypto-js';


const SECRET_KEY = process.env.REACT_APP_STORAGE_KEY || 'default-fallback-key-change-in-production';

export const secureStorage = {
  setItem: (key: string, value: string) => {
    try {
      const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
      localStorage.setItem(key, encrypted);
    } catch (error) {
      console.error('Error encrypting data:', error);
      // Fallback to regular localStorage
      localStorage.setItem(key, value);
    }
  },
  
  getItem: (key: string): string | null => {
    try {
      const encrypted = localStorage.getItem(key);
      if (!encrypted) return null;
      
      const decrypted = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      
      // If decryption fails, it might be unencrypted data (backward compatibility)
      if (!decryptedString) {
        return encrypted;
      }
      
      return decryptedString;
    } catch (error) {
      console.error('Error decrypting data:', error);
      // Fallback to regular localStorage
      return localStorage.getItem(key);
    }
  },
  
  removeItem: (key: string) => {
    localStorage.removeItem(key);
  }
};
